// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";

import $ from "jquery";
import bootstrap from "bootstrap";

import validation from "jquery-validation";
// import tether from 'tether'
import moment from "moment";
import serializeJSON from "jquery-serializejson";
// import pace from 'pace'
import Antd from "ant-design-vue";

import "../static/plugins/bootstrap/dist/css/bootstrap.min.css";
import "../static/plugins/themify-icons/css/themify-icons.css";
import "../static/plugins/swiper-5.1.0/package/css/swiper.min.css";
import "../static/plugins/fullcalendar/dist/fullcalendar.min.css";

import "../static/css/first-layout.css";
import "ant-design-vue/dist/antd.css";
import "../static/css/style.scss";
import "@/assets/style/common.scss";
import "@/assets/style/helper.scss";

Vue.config.productionTip = false;
Vue.use(Antd);
Vue.use(require("vue-moment"));
//Vue.use(FullCalendar);
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js